"use strict";
import '@splidejs/splide/src/css/template/default/index.scss';
import "../scss/style.scss";
import './firstview/_index';
import './calculateScroll/_index'
import './space/_index';
import './scrollAnimation/_index';
import './map/_index';
import './scrollTop/_index';
import './headerMenu/_index';
import './stickyScroll/_index';
import './splide/_index';
import './accordion/_index';
import './vivus/_index';
import './blocks/front/_PriceGroupFront';
// import './css_load';
// 
// //ポスト切り替えボタン

document.addEventListener('DOMContentLoaded', function () {
    const site_url = tmp_path['site_url'] + '/';
    const current_url = location.href;
    const buttons = document.querySelectorAll('.category-button');
    const container = document.getElementById('posts-container');

    // 初期ロード時にローカルストレージからページ番号、カテゴリID、年、月を取得
    const savedPage = localStorage.getItem('currentPage') || '1';
    let savedCategoryId = '';
    if (site_url == current_url) {
        savedCategoryId = 'all';
    } else {
        savedCategoryId = localStorage.getItem('currentCategoryId') || 'all';
    }
    const savedYear = localStorage.getItem('currentYear');
    const savedMonth = localStorage.getItem('currentMonth');

    if (container) {
        console.log(savedCategoryId);
        fetchPosts(savedCategoryId, savedPage, savedYear, savedMonth);
        const categoryButton = document.querySelector(`.category-button[data-category="${savedCategoryId ?? 'all'}"]`);
        if (categoryButton) {
            categoryButton.classList.add('active');
        } else {
            document.querySelector(`.category-button[data-category="all"]`).classList.add('active');
        }
    }

    buttons.forEach(function (button) {
        button.addEventListener('click', function () {
            buttons.forEach(btn => btn.classList.remove('active'));
            this.classList.add('active');
            const categoryId = this.getAttribute('data-category');
            if (container) {
                fetchPosts(categoryId);
            }
            localStorage.setItem('currentPage', '1');
            localStorage.setItem('currentCategoryId', categoryId);
        });
    });

    if (container) {
        container.addEventListener('click', function (e) {
            const target = e.target.closest('a');
            if (target && target.parentNode.classList.contains('pagination')) {
                e.preventDefault();
                const page = new URL(target.href).searchParams.get('paged');
                if (page) {
                    const categoryId = document.querySelector('.category-button.active').getAttribute('data-category');
                    fetchPosts(categoryId, page);
                    localStorage.setItem('currentPage', page);
                    window.scrollTo(0, 0);
                }
            }
        });
    }
});

function fetchPosts(categoryId, page = 1, year = null, month = null) {
    if (customNewsSettings) {
        const postsPerPage = customNewsSettings.postsPerPage;
        const pagesEnabled = customNewsSettings.pagesEnabled;
        let fetchUrl = `${frontendajax.ajaxurl}?action=fetch_posts&category_id=${categoryId}&posts_per_page=${postsPerPage}&pages=${pagesEnabled}&paged=${page}`;

        if (year && month) {
            fetchUrl += `&year=${year}&month=${month}`;
        }

        fetch(fetchUrl)
            .then(response => response.json())
            .then(data => {
                const parser = new DOMParser();
                const doc = parser.parseFromString(data.html, 'text/html');
                document.getElementById('posts-container').innerHTML = doc.body.innerHTML;
            })
            .catch(error => {
                console.error('Error:', error);
                document.getElementById('posts-container').innerHTML = '<p>データを読み込む際に問題が発生しました。しばらくしてから再度試してください。</p>';
            });
    }
}
document.addEventListener('DOMContentLoaded', function () {
    var div = document.querySelector('.js-contact-form-wrap');
    if (div) {
        // 新しいlabelタグを作成
        var label = document.createElement('label');

        // 元のdivの属性をコピー
        for (var i = 0; i < div.attributes.length; i++) {
            var attr = div.attributes[i];
            label.setAttribute(attr.name, attr.value);
        }

        // 子要素をコピー
        while (div.firstChild) {
            label.appendChild(div.firstChild);
        }

        // 元のdivをlabelに置き換え
        div.parentNode.replaceChild(label, div);
    }
});
